import { Box, Button, Center, Flex, Grid, Heading, Text } from '@chakra-ui/react';
import {
  AccordionRoot,
  customScrollbarStyles,
  Drawer,
  DrawerBottomButtonsContainer,
  FilterIcon,
  KollectionsFilterGroupCheckboxList,
  KollectionsFilterGroupToggle,
  KollectionsSearchBox,
  pxToRem,
  useKollections,
} from '@cyberkongz/ui';

function KollectionFiltersList() {
  const { kollectionStringTraits } = useKollections();

  return (
    <Box
      maxW={[pxToRem(480), `calc(100% - ${pxToRem(16)})`]}
      alignSelf="flex-start"
      pr={[0, null, 1]}
      pb={[pxToRem(160), null, 0]}
      mx={['auto', 0]}
    >
      <Grid gap={3} mb={[4, null, 2]}>
        <Heading size="xs">Filters</Heading>
        <KollectionsSearchBox />
      </Grid>
      <AccordionRoot multiple defaultValue={[]}>
        {kollectionStringTraits.map((filter) =>
          filter.traitType.includes('Legendary') ? (
            <KollectionsFilterGroupToggle key={filter.traitType} />
          ) : (
            <KollectionsFilterGroupCheckboxList key={filter.traitType} {...filter} />
          )
        )}
      </AccordionRoot>
    </Box>
  );
}
export function KollectionsFilters() {
  const { modals, clearFilters, toggleModal, stringTraits } = useKollections();
  const filtersCount = stringTraits.reduce((sum, stringTrait) => {
    sum += stringTrait.values.length;

    return sum;
  }, 0);

  return (
    <>
      <Flex
        onClick={() => toggleModal('filters')}
        cursor="pointer"
        alignItems="center"
        fontWeight="medium"
        gap={1}
      >
        <Text>Filters</Text>
        <FilterIcon width={6} height={6} />
        {filtersCount > 0 ? (
          <Center
            bg="primary"
            boxSize={pxToRem(18)}
            fontSize="xs"
            color="textAlt"
            borderRadius="sm"
            lineHeight="0.9"
            ml={1}
          >
            {filtersCount}
          </Center>
        ) : null}
      </Flex>
      <Drawer
        open={modals.filters}
        onOpenChange={() => toggleModal('filters')}
        styles={{
          content: {
            maxWidth: ['none', pxToRem(380)],
          },
          body: customScrollbarStyles,
        }}
      >
        <KollectionFiltersList />
        <DrawerBottomButtonsContainer>
          <Grid gridTemplateColumns="1fr 1fr" gap={3}>
            <Button onClick={clearFilters} variant="displayOutline">
              Clear All
            </Button>
            <Button variant="display" onClick={() => toggleModal('filters')}>
              Done
            </Button>
          </Grid>
        </DrawerBottomButtonsContainer>
      </Drawer>
    </>
  );
}
